"use strict";

var __values = this && this.__values || function (o) {
  var m = typeof Symbol === "function" && o[Symbol.iterator],
      i = 0;
  if (m) return m.call(o);
  return {
    next: function next() {
      if (o && i >= o.length) o = void 0;
      return {
        value: o && o[i++],
        done: !o
      };
    }
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var LocalStorage =
/** @class */
function () {
  function LocalStorage(window, storage) {
    var _this = this;

    this._events = {};

    if (window) {
      this.supported = true;
    } else {
      this.supported = false;
      window = new Window();
    }

    this.storage = storage || window.localStorage;
    listen(window, function (_a) {
      var key = _a.key,
          newValue = _a.newValue;
      if (!key) return;

      _this.feed(key, newValue);
    });
  }

  Object.defineProperty(LocalStorage.prototype, "length", {
    get: function get() {
      return this.storage.length;
    },
    enumerable: true,
    configurable: true
  });

  LocalStorage.prototype.key = function (index) {
    return this.storage.key(index);
  };

  LocalStorage.prototype.getItem = function (key) {
    return this.storage.getItem(key);
  };

  LocalStorage.prototype.setItem = function (key, value) {
    this.storage.setItem(key, value);
    this.emit('change', key, value);
  };

  LocalStorage.prototype.removeItem = function (key) {
    this.storage.removeItem(key);
    this.emit('change', key, null);
  };

  LocalStorage.prototype.clear = function () {
    this.storage.clear();
  };

  LocalStorage.prototype.on = function (name, fn) {
    var set = this._events[name];

    if (!set) {
      this._events[name] = set = new Set();
    }

    set.add(fn);
  };

  LocalStorage.prototype.off = function (name, fn) {
    var set = this._events[name];

    if (set) {
      set.delete(fn);
    }
  };

  LocalStorage.prototype.feed = function (key, newValue) {
    this.emit('change', key, newValue);
  };

  LocalStorage.prototype.emit = function (name) {
    var args = [];

    for (var _i = 1; _i < arguments.length; _i++) {
      args[_i - 1] = arguments[_i];
    }

    var e_1, _a;

    var set = this._events[name];

    if (set) {
      try {
        for (var _b = __values(set.values()), _c = _b.next(); !_c.done; _c = _b.next()) {
          var fn = _c.value;
          fn.apply(null, args);
        }
      } catch (e_1_1) {
        e_1 = {
          error: e_1_1
        };
      } finally {
        try {
          if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally {
          if (e_1) throw e_1.error;
        }
      }
    }
  };

  return LocalStorage;
}();

exports.LocalStorage = LocalStorage;

function listen(target, cb) {
  if (target.addEventListener) {
    target.addEventListener('storage', cb, true);
  } else if (target.attachEvent) {
    target.attachEvent('storage', cb);
  } else {
    return false;
  }

  return true;
}

exports.listen = listen;